export class TodayWeather {
    day: string;
    min_temp: number;
    max_temp: number;
    sunrise: string;
    sunset: string;
    weather: string;
    image:string
}